module.exports = __webpack_public_path__ + "static/media/Raffrollo_35618_100x160.24500853.png";